import { useEffect, useState } from "react";

type UseIsOpen = {
	defaultIsOpen?: boolean;
	onToggleChange?: (isOpen: boolean) => void;
	isEnabled?: boolean;
};

export const useIsOpen = ({
	defaultIsOpen = false,
	onToggleChange,
	isEnabled = true,
}: UseIsOpen = {}) => {
	const [isOpen, setIsOpen] = useState(defaultIsOpen);

	const toggleIsOpen = () => {
		if (isEnabled) {
			setIsOpen((oldIsOpen) => !oldIsOpen);
		}
	};

	const open = () => {
		if (isEnabled) {
			setIsOpen(true);
		}
	};

	const close = () => {
		if (isEnabled) {
			setIsOpen(false);
		}
	};

	useEffect(() => {
		onToggleChange?.(isOpen);
	}, [isOpen]);

	return {
		isOpen,
		setIsOpen,
		toggleIsOpen,
		open,
		close,
	};
};

export type UseIsOpenReturn = ReturnType<typeof useIsOpen>;
